var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "audiences-config" }, [
        _c("div", { staticClass: "audiences-config__tablewrap" }, [
          _c("div", { staticClass: "audiences-config__cardbody" }, [
            _c("div", { staticClass: "audiences-config__cardhead" }, [
              _c("div", { staticClass: "audiences-config__search" }, [
                _c("i", {
                  staticClass: "bi bi-search audiences-config__searchicon",
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.audiencesSearchQuery,
                      expression: "audiencesSearchQuery",
                    },
                  ],
                  staticClass: "form-control audiences-config__searchinput",
                  attrs: { type: "text", placeholder: "Search audiences..." },
                  domProps: { value: _vm.audiencesSearchQuery },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.audiencesSearchQuery = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _vm.audiencesSearchQuery
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-link audiences-config__clear",
                        attrs: { type: "button", title: "Clear search" },
                        on: {
                          click: function ($event) {
                            _vm.audiencesSearchQuery = ""
                          },
                        },
                      },
                      [_c("i", { staticClass: "bi bi-x-circle" })]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-primary btn-sm audiences-config__primary d-flex align-items-center btn-library",
                  on: {
                    click: function ($event) {
                      return _vm.showAudienceModal("create")
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "mr-1",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    },
                    [
                      _c("path", { attrs: { d: "M5 12h14" } }),
                      _vm._v(" "),
                      _c("path", { attrs: { d: "M12 5v14" } }),
                    ]
                  ),
                  _vm._v("\n            Add New Audience\n          "),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "audiences-config__tablebox" }, [
              _c(
                "div",
                { staticClass: "audiences-config__tableinner" },
                [
                  _vm.isLoadingAudiences || _vm.audiences.length > 0
                    ? [
                        _c("table", { staticClass: "audiences-table mb-0" }, [
                          _c("thead", [
                            _c("tr", [
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "sortable audiences-table__th audiences-table__th--audience",
                                  on: {
                                    click: function ($event) {
                                      return _vm.sortAudiences("name")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                      Audience\n                      "
                                  ),
                                  _vm.audiencesSortBy === "name"
                                    ? _c("i", {
                                        staticClass: "fas",
                                        class: {
                                          "fa-sort-up":
                                            _vm.audiencesSortOrder === "asc",
                                          "fa-sort-down":
                                            _vm.audiencesSortOrder === "desc",
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "sortable audiences-table__th audiences-table__th--segment",
                                  on: {
                                    click: function ($event) {
                                      return _vm.sortAudiences("segment")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                      Segment\n                      "
                                  ),
                                  _vm.audiencesSortBy === "segment"
                                    ? _c("i", {
                                        staticClass: "fas",
                                        class: {
                                          "fa-sort-up":
                                            _vm.audiencesSortOrder === "asc",
                                          "fa-sort-down":
                                            _vm.audiencesSortOrder === "desc",
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "sortable audiences-table__th audiences-table__th--category",
                                  on: {
                                    click: function ($event) {
                                      return _vm.sortAudiences("category")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                      Category\n                      "
                                  ),
                                  _vm.audiencesSortBy === "category"
                                    ? _c("i", {
                                        staticClass: "fas",
                                        class: {
                                          "fa-sort-up":
                                            _vm.audiencesSortOrder === "asc",
                                          "fa-sort-down":
                                            _vm.audiencesSortOrder === "desc",
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "sortable audiences-table__th audiences-table__th--brand",
                                  on: {
                                    click: function ($event) {
                                      return _vm.sortAudiences("brand")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                      Brand\n                      "
                                  ),
                                  _vm.audiencesSortBy === "brand"
                                    ? _c("i", {
                                        staticClass: "fas",
                                        class: {
                                          "fa-sort-up":
                                            _vm.audiencesSortOrder === "asc",
                                          "fa-sort-down":
                                            _vm.audiencesSortOrder === "desc",
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "sortable audiences-table__th audiences-table__th--description",
                                  on: {
                                    click: function ($event) {
                                      return _vm.sortAudiences("description")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                      Description\n                      "
                                  ),
                                  _vm.audiencesSortBy === "description"
                                    ? _c("i", {
                                        staticClass: "fas",
                                        class: {
                                          "fa-sort-up":
                                            _vm.audiencesSortOrder === "asc",
                                          "fa-sort-down":
                                            _vm.audiencesSortOrder === "desc",
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "audiences-table__th audiences-table__th--actions",
                                },
                                [
                                  _vm._v(
                                    "\n                      Actions\n                    "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            [
                              _vm.isLoadingAudiences
                                ? _c("tr", [_vm._m(0)])
                                : _vm.sortedAudiences.length === 0 &&
                                  _vm.audiencesSearchQuery
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "text-center",
                                        attrs: { colspan: "6" },
                                      },
                                      [
                                        _c("div", { staticClass: "py-4" }, [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-search fa-3x text-muted mb-3",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "text-muted" },
                                            [
                                              _vm._v(
                                                '\n                          No audiences found matching "' +
                                                  _vm._s(
                                                    _vm.audiencesSearchQuery
                                                  ) +
                                                  '".\n                        '
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-secondary",
                                              on: {
                                                click: function ($event) {
                                                  _vm.audiencesSearchQuery = ""
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                          Clear Search\n                        "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ])
                                : _vm._l(
                                    _vm.sortedAudiences,
                                    function (audience) {
                                      return _c("tr", { key: audience.id }, [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "audiences-table__td audiences-table__td--name",
                                          },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(audience.name) +
                                                "\n                      "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "audiences-table__td audiences-table__td--muted audiences-table__td--segment",
                                            attrs: {
                                              title: audience.segment || "-",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  audience.segment || "-"
                                                ) +
                                                "\n                      "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "audiences-table__td audiences-table__td--muted audiences-table__td--category",
                                            attrs: {
                                              title: audience.category || "-",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  audience.category || "-"
                                                ) +
                                                "\n                      "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "audiences-table__td audiences-table__td--muted audiences-table__td--brand",
                                            attrs: {
                                              title: audience.brand || "-",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(audience.brand || "-") +
                                                "\n                      "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "audiences-table__td audiences-table__td--muted audiences-table__td--description",
                                            attrs: {
                                              title:
                                                audience.description || "-",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "audiences-table__cell audiences-table__cell--ellipsis",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          " +
                                                    _vm._s(
                                                      audience.description ||
                                                        "-"
                                                    ) +
                                                    "\n                        "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "audiences-table__td audiences-table__td--actions text-right",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex audiences-config__actions",
                                                attrs: { role: "group" },
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "audiences-config__actionbtn audiences-config__actionbtn--edit",
                                                    attrs: { title: "Edit" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.editAudience(
                                                          audience
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        attrs: {
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg",
                                                          width: "24",
                                                          height: "24",
                                                          viewBox: "0 0 24 24",
                                                          fill: "none",
                                                          stroke:
                                                            "currentColor",
                                                          "stroke-width": "2",
                                                          "stroke-linecap":
                                                            "round",
                                                          "stroke-linejoin":
                                                            "round",
                                                          "aria-hidden": "true",
                                                        },
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("path", {
                                                          attrs: {
                                                            d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      "\n                            Edit\n                          "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "audiences-config__actionbtn audiences-config__actionbtn--delete",
                                                    attrs: { title: "Delete" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.deleteAudience(
                                                          audience
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        attrs: {
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg",
                                                          width: "24",
                                                          height: "24",
                                                          viewBox: "0 0 24 24",
                                                          fill: "none",
                                                          stroke:
                                                            "currentColor",
                                                          "stroke-width": "2",
                                                          "stroke-linecap":
                                                            "round",
                                                          "stroke-linejoin":
                                                            "round",
                                                          "aria-hidden": "true",
                                                        },
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            d: "M3 6h18",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("path", {
                                                          attrs: {
                                                            d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("path", {
                                                          attrs: {
                                                            d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("line", {
                                                          attrs: {
                                                            x1: "10",
                                                            x2: "10",
                                                            y1: "11",
                                                            y2: "17",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("line", {
                                                          attrs: {
                                                            x1: "14",
                                                            x2: "14",
                                                            y1: "11",
                                                            y2: "17",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      "\n                            Delete\n                          "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ])
                                    }
                                  ),
                            ],
                            2
                          ),
                        ]),
                      ]
                    : _c("table", { staticClass: "audiences-table mb-0" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("tbody", [
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "text-center",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "py-4 d-flex flex-column align-items-center",
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "bi bi-people",
                                      staticStyle: {
                                        "font-size": "3rem",
                                        color: "#e2e8f0",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-primary btn-library mt-3",
                                        on: {
                                          click: function ($event) {
                                            return _vm.showAudienceModal(
                                              "create"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "bi bi-plus-circle mr-1",
                                        }),
                                        _vm._v(
                                          "\n                        Create Your First Audience\n                      "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                ],
                2
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "audience-modal",
            size: "lg",
            "header-class": "border-bottom-0 pb-0",
            "footer-class": "border-top-0 pt-0",
            "cancel-variant": "outline-secondary",
            "ok-title": `Save ${
              _vm.audienceModalMode === "create" ? "" : "Changes"
            }`,
            "ok-disabled": _vm.isSaveAudienceDisabled,
          },
          on: { ok: _vm.saveAudience, hidden: _vm.resetAudienceModal },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [
                  _c("h5", { staticClass: "m-0" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.audienceModalMode === "create"
                            ? "Add New Audience"
                            : "Edit Audience"
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-muted font-lg" }, [
                    _vm._v(
                      "\n        Define your target audience with detailed characteristics and demographics.\n      "
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.showAudienceModalFlag,
            callback: function ($$v) {
              _vm.showAudienceModalFlag = $$v
            },
            expression: "showAudienceModalFlag",
          },
        },
        [
          _vm._v(" "),
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.saveAudience.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "b-form-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Audience Name *",
                            "label-class": "font-weight-bold",
                          },
                        },
                        [
                          _c("b-input", {
                            attrs: { autofocus: "", required: "" },
                            model: {
                              value: _vm.currentAudience.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.currentAudience, "name", $$v)
                              },
                              expression: "currentAudience.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Segment",
                            "label-class": "font-weight-bold",
                          },
                        },
                        [
                          _c("b-input", {
                            attrs: { placeholder: "e.g., Millennials" },
                            model: {
                              value: _vm.currentAudience.segment,
                              callback: function ($$v) {
                                _vm.$set(_vm.currentAudience, "segment", $$v)
                              },
                              expression: "currentAudience.segment",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Category",
                            "label-class": "font-weight-bold",
                          },
                        },
                        [
                          _c("b-input", {
                            attrs: { placeholder: "e.g., Fashion" },
                            model: {
                              value: _vm.currentAudience.category,
                              callback: function ($$v) {
                                _vm.$set(_vm.currentAudience, "category", $$v)
                              },
                              expression: "currentAudience.category",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Brand",
                            "label-class": "font-weight-bold",
                          },
                        },
                        [
                          _c("b-input", {
                            attrs: { placeholder: "e.g., Nike" },
                            model: {
                              value: _vm.currentAudience.brand,
                              callback: function ($$v) {
                                _vm.$set(_vm.currentAudience, "brand", $$v)
                              },
                              expression: "currentAudience.brand",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-0",
                          attrs: {
                            label: "Description *",
                            "label-class": "font-weight-bold",
                          },
                        },
                        [
                          _c("b-textarea", {
                            attrs: {
                              rows: "7",
                              placeholder: "Describe this audience segment...",
                              required: "",
                            },
                            model: {
                              value: _vm.currentAudience.description,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.currentAudience,
                                  "description",
                                  $$v
                                )
                              },
                              expression: "currentAudience.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-2", attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Extract from document using AI (optional)",
                            "label-class": "font-weight-bold",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "border rounded py-4 text-center cursor-pointer",
                              class: {
                                "border-primary bg-light": _vm.isPdfDragOver,
                                "border-secondary": !_vm.isPdfDragOver,
                              },
                              on: {
                                dragover: function ($event) {
                                  $event.preventDefault()
                                  return _vm.onPdfDragOver.apply(
                                    null,
                                    arguments
                                  )
                                },
                                dragleave: function ($event) {
                                  $event.preventDefault()
                                  return _vm.onPdfDragLeave.apply(
                                    null,
                                    arguments
                                  )
                                },
                                drop: function ($event) {
                                  $event.preventDefault()
                                  return _vm.onPdfDrop.apply(null, arguments)
                                },
                                click: function ($event) {
                                  return _vm.$refs.audiencePdfInput.click()
                                },
                              },
                            },
                            [
                              _c("p", { staticClass: "mb-1" }, [
                                _c("strong", [
                                  _vm._v("Drag & drop a file here"),
                                ]),
                                _vm._v(" or click to select\n              "),
                              ]),
                              _vm._v(" "),
                              _c(
                                "small",
                                { staticClass: "text-muted d-block" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.selectedAudiencePdfName ||
                                          "Supported: PDF, DOCX, PPTX"
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            ref: "audiencePdfInput",
                            staticClass: "d-none",
                            attrs: {
                              type: "file",
                              accept:
                                "application/pdf,.docx,.pptx,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.presentationml.presentation",
                            },
                            on: { change: _vm.onAudiencePdfChange },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.audiencePdfText
                    ? _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Extraction type",
                                "label-class": "font-weight-bold",
                              },
                            },
                            [
                              _c("b-form-select", {
                                attrs: { options: _vm.guidelineTypeOptions },
                                model: {
                                  value: _vm.guidelineExtractionType,
                                  callback: function ($$v) {
                                    _vm.guidelineExtractionType = $$v
                                  },
                                  expression: "guidelineExtractionType",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.audiencePdfText
                    ? _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Number of guidelines",
                                "label-class": "font-weight-bold",
                              },
                            },
                            [
                              _c("b-form-select", {
                                attrs: { options: _vm.guidelineCountOptions },
                                model: {
                                  value: _vm.guidelineCount,
                                  callback: function ($$v) {
                                    _vm.guidelineCount = $$v
                                  },
                                  expression: "guidelineCount",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.audiencePdfText
                    ? _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "primary",
                                block: "",
                                disabled: _vm.isGeneratingDescription,
                              },
                              on: { click: _vm.generateGuidelinesFromPdf },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.isGeneratingDescription
                                      ? "Processing..."
                                      : "Generate description"
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Confirm Delete" },
          on: { ok: _vm.confirmDeleteAudience },
          model: {
            value: _vm.showDeleteConfirmModal,
            callback: function ($$v) {
              _vm.showDeleteConfirmModal = $$v
            },
            expression: "showDeleteConfirmModal",
          },
        },
        [
          _c("p", [
            _vm._v(
              "\n      Are you sure you want to delete the audience\n      "
            ),
            _c("strong", [_vm._v(_vm._s(_vm.audienceToDelete?.name))]),
            _vm._v(" ?\n    "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-muted mb-0" }, [
            _vm._v("\n      This action cannot be undone.\n    "),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "text-center", attrs: { colspan: "6" } }, [
      _c("span", {
        staticClass: "spinner-grow spinner-grow-sm",
        attrs: { role: "status", "aria-hidden": "true" },
      }),
      _vm._v("\n                      Loading...\n                    "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c(
          "th",
          { staticClass: "audiences-table__th audiences-table__th--audience" },
          [_vm._v("\n                    Audience\n                  ")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "audiences-table__th audiences-table__th--segment" },
          [_vm._v("\n                    Segment\n                  ")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "audiences-table__th audiences-table__th--category" },
          [_vm._v("\n                    Category\n                  ")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "audiences-table__th audiences-table__th--brand" },
          [_vm._v("\n                    Brand\n                  ")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticClass: "audiences-table__th audiences-table__th--description",
          },
          [_vm._v("\n                    Description\n                  ")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "audiences-table__th audiences-table__th--actions" },
          [_vm._v("\n                    Actions\n                  ")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }